import type { Test } from '@/data'
import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import api from '..'

export type PaginatedTests = PaginatedResponse<Test>

export async function getTests(params?: ListParams): Promise<PaginatedTests> {
  const res = await api.get('/flow_experiments', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
